<template>
  <div class="inventory">
    <div class="col-12">
      <div class="row">
        <div class="col-6">
          <h2>Pot Size Detail</h2>
        </div>
      </div>
    </div>

    <div class="col-12" @submit.prevent="handleSubmit" v-if="selectedItem">
      <div class="row">
        <div class="col-2">
          <label for="name"> Description: </label>
        </div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            id="pot_size_description"
            ref="description"
            name="name"
            placeholder="name"
            :value="getDescription()"
          />
        </div>

        <div
          v-if="submitted && errors.has('name')"
          class="col-12 invalid-feedback"
        >
          {{ errors.first("name") }}
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-10">
        <button id="new" @click="$emit('new')" class="btn btn-plt">New</button>
        <button v-if="selectedItem" id="save" @click="save" class="btn btn-plt">
          Save
        </button>
      </div>

      <div class="col-2" v-if="selectedItem">
        <button
          id="delete"
          v-if="selectedItem.active"
          @click="_delete"
          class="btn btn-danger"
        >
          Delete
        </button>
        <button id="delete" v-else @click="_delete" class="btn btn-primary">
          Reactivate
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "PlantVarietyDetail",

  // Props
  props: {
    selectedItem: {
      type: Object,
      default: null,
    },
  },

  // DATA
  data: () => ({
    submitted: false,
  }),

  // Computed
  computed: {},

  // METHODS
  methods: {
    ...mapActions("inventory", ["apiSavePotSize", "apiCreatePotSize"]),

    handleSubmit() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.save();
        }
      });
    },

    // Make "active" false
    _delete() {
      if (this.selectedItem && this.selectedItem.id > 0) {
        this.selectedItem.active = !this.selectedItem.active;
        this.apiSavePotSize(this.selectedItem);
      }
    },

    save() {
      if (this.selectedItem) {
        if (!this.$refs.description.value) {
          alert("please enter a description");
          return;
        }
        this.selectedItem.description = this.$refs.description.value;
        this.selectedItem.active = true;

        if (this.selectedItem.id > 0) {
          this.apiSavePotSize(this.selectedItem);
        } else {
          this.apiCreatePotSize(this.selectedItem);
        }
        this.$emit("saved");
      }
    },

    getDescription() {
      if (this.selectedItem == null) {
        return "";
      } else {
        return this.selectedItem.description;
      }
    },

    getBotany() {
      if (this.selectedItem == null) {
        return "";
      } else {
        return this.selectedItem.botany;
      }
    },
  },

  // Component
  component: {},
};
</script>
